import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';

const resetScrollPosition = () => window.scrollTo(0, 0);

const NavButton = (props) => {
  const {
    text, icon, target, exact,
  } = props;

  return (
    <li>
      <NavLink onClick={resetScrollPosition} activeClassName="is-active" exact={exact} to={target}>
        {icon && <FontAwesomeIcon icon={icon.replace('fa-', '').split(' ')} />}
        {i18n.translate(`nav.${text}`)}
      </NavLink>
    </li>
  );
};

const ButtonSet = (props) => {
  const { buttons, orientation } = props;
  const buttonElements = Object.values(buttons).map(button => (
    <NavButton key={button.text} {...button} />
  ));

  return (
    <ul className={orientation}>{buttonElements}</ul>
  );
};

export default ButtonSet;

NavButton.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  target: PropTypes.string,
  exact: PropTypes.bool,
};

NavButton.defaultProps = {
  text: '',
  icon: null,
  target: '/',
  exact: true,
};

ButtonSet.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape()),
  orientation: PropTypes.string,
};

ButtonSet.defaultProps = {
  buttons: {},
  orientation: 'left',
};
